import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

// Firebase init
var firebaseConfig = {
  apiKey: "AIzaSyBVDAq5y1D0lSub5Wm7iVqFlAFSrcDr1uY",
  authDomain: "luny-comics.firebaseapp.com",
  databaseURL: "https://luny-comics.firebaseio.com",
  projectId: "luny-comics",
  storageBucket: "luny-comics.appspot.com",
  messagingSenderId: "1032050467356",
  appId: "1:1032050467356:web:74ddf80f9828dc7dbdf5d9",
  measurementId: "G-PBCTLNCGC4"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

// Utils
const db = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()

// Collection References
const comicsCollection = db.collection('comics')
const illustrationsCollection = db.collection('illustrations')

export {
  db, 
  storage, 
  auth,
  comicsCollection, 
  illustrationsCollection
}